const compare = (a, b) => a.id - b.id

export default function buildItemHistory(events) {
  const histories = []
  let clone = {}
  
  events = [...events].sort(compare)
  events.forEach(event => {
    clone = {...clone, _id: event.id, _author: event.author, _action: event.action, _created_at: event.created_at}
    Object.entries(event.mutation).forEach(([key, value]) => {
      const newValue = value[1]

      if (newValue === null)
        delete clone[key]
      else
        clone[key] = newValue
    })
    
    histories.push(clone)
  })

  return histories
}
